var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.82857C0 1.27846 1.23353 0 2.78182 0H22.4182C23.9665 0 25.2 1.27846 25.2 2.82857V9C25.2 9.33132 24.9313 9.6 24.6 9.6C24.2687 9.6 24 9.33132 24 9V2.82857C24 1.91708 23.2799 1.2 22.4182 1.2H2.78182C1.92013 1.2 1.2 1.91708 1.2 2.82857V13.9715C1.2 14.8829 1.92013 15.6 2.78182 15.6H11.4C11.7313 15.6 12 15.8687 12 16.2C12 16.5313 11.7313 16.8 11.4 16.8H2.78182C1.23353 16.8 0 15.5215 0 13.9715V2.82857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.20156C0 3.87019 0.26863 3.60156 0.6 3.60156H24.6C24.9313 3.60156 25.2 3.87019 25.2 4.20156C25.2 4.53293 24.9313 4.80156 24.6 4.80156H0.6C0.26863 4.80156 0 4.53293 0 4.20156Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40002 10.2016C2.40002 9.87024 2.66866 9.60156 3.00002 9.60156H5.40002C5.73139 9.60156 6.00002 9.87024 6.00002 10.2016C6.00002 10.5329 5.73139 10.8016 5.40002 10.8016H3.00002C2.66866 10.8016 2.40002 10.5329 2.40002 10.2016Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40002 13.2016C2.40002 12.8702 2.66866 12.6016 3.00002 12.6016H7.80002C8.13139 12.6016 8.40002 12.8702 8.40002 13.2016C8.40002 13.5329 8.13139 13.8016 7.80002 13.8016H3.00002C2.66866 13.8016 2.40002 13.5329 2.40002 13.2016Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.0008C18.0177 12.0008 15.6 14.4184 15.6 17.4008C15.6 20.3831 18.0177 22.8008 21 22.8008C23.9824 22.8008 26.4 20.3831 26.4 17.4008C26.4 14.4184 23.9824 12.0008 21 12.0008ZM14.4 17.4008C14.4 13.7557 17.3549 10.8008 21 10.8008C24.6451 10.8008 27.6 13.7557 27.6 17.4008C27.6 21.0459 24.6451 24.0008 21 24.0008C17.3549 24.0008 14.4 21.0459 14.4 17.4008Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9757 16.3749C23.21 16.1407 23.5899 16.1407 23.8243 16.3749C24.0585 16.6093 24.0585 16.9892 23.8243 17.2235L21.4243 19.6235C21.1899 19.8578 20.81 19.8578 20.5757 19.6235L18.7757 17.8235C18.5414 17.5892 18.5414 17.2093 18.7757 16.9749C19.01 16.7407 19.3899 16.7407 19.6243 16.9749L21 18.3507L22.9757 16.3749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.e583c26548afb7a7f5986e128ad05bdf.svg";
export { ForwardRef as ReactComponent };